export default __webpack_public_path__ + "static/media/s5.cb2f0180.jpg";